export default "__VITE_ASSET__DoVjok0$__"